import React from "react";
import { Typography, Toolbar } from "@material-ui/core";
import brandlogo from "../assets/logo192.png";

function Branding({children}) {
  return (
    <Toolbar>
      <img src={brandlogo} alt="brand-logo" width="32px" height="32px" />
      <Typography style={{ paddingLeft: 6 }} variant="h6">
        ChatApp
      </Typography>
      {children || ""}
    </Toolbar>
  );
}

export default Branding;
